import { render, staticRenderFns } from "./DislikesInput.vue?vue&type=template&id=56bb7065"
import script from "./DislikesInput.vue?vue&type=script&lang=js"
export * from "./DislikesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports